import { ICalltrackingSchema } from '../../../../../repositories/billing-tariffs/v1/publish-terms';
import { ICalltracking } from '../../../../../redux/reducers';
import { mapPeriod } from '../mapPeriod';
import { isCalltrackingEnabled } from './isCalltrackingEnabled';

export const mapCalltracking = (calltrackingTerm?: ICalltrackingSchema | null): ICalltracking => {
  const {
    isAvailable = false,
    isCompulsory = false,
    incompatibleServices,
    period: rawPeriod,
    calltrackingPhoneSubstitutionsCount = null,
  } = calltrackingTerm || {};

  const period = rawPeriod ? mapPeriod(rawPeriod) : null;

  const isPaid = !!rawPeriod?.isPaid;
  const isEnabled = isCalltrackingEnabled({ isAvailable, isCompulsory, isPaid });

  return {
    isAvailable,
    isEnabled,
    incompatibleServices: incompatibleServices || [],
    isCompulsory,
    calltrackingPhoneSubstitutionsCount,
    period,
  };
};
